import {
    LANGUAGE_OVERRIDE_STORAGE_KEY,
    TRANSLATION_CACHE_VERSION
} from "mock-data/translation/languages";


const memoryCache = {};

const getStorage = () => {
    try {
        return window.localStorage;
    } catch (e) {
        return null;
    }
};

export const hashText = (value = "") => {
    const str = String(value);
    let hash = 2166136261;

    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }

    return (hash >>> 0).toString(16);
};

const readJSON = (key, fallback = null) => {
    const storage = getStorage();

    if (!storage) return fallback;

    try {
        const raw = storage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
        return fallback;
    }
};

const writeJSON = (key, value) => {
    const storage = getStorage();

    if (!storage) return;

    try {
        storage.setItem(key, JSON.stringify(value));
    } catch (e) {}
};

export const getLanguageOverride = () => {
    const storage = getStorage();

    if (!storage) return null;

    return storage.getItem(LANGUAGE_OVERRIDE_STORAGE_KEY) || null;
};

export const setLanguageOverride = (language) => {
    const storage = getStorage();

    if (!storage) return;

    if (!language) {
        storage.removeItem(LANGUAGE_OVERRIDE_STORAGE_KEY);
        return;
    }

    storage.setItem(LANGUAGE_OVERRIDE_STORAGE_KEY, language);
};

export const getTextCacheKey = ({
        sourceLang = "",
        targetLang = "",
        namespace = "data",
        context = "",
        text = ""
    }) => {
    const hash = hashText(`${ context }::${ text }`);
    return `translation:${ TRANSLATION_CACHE_VERSION }:${ sourceLang }:${ targetLang }:${ namespace }:${ hash }`;
};

export const getCachedText = (params) => {
    const key = getTextCacheKey(params);

    if (memoryCache[key]) return memoryCache[key];

    const value = readJSON(key);

    if (value) memoryCache[key] = value;

    return value;
};

export const setCachedText = (params, translatedText) => {
    const key = getTextCacheKey(params);
    const value = {
        translatedText,
        updatedAt: Date.now()
    };

    memoryCache[key] = value;
    writeJSON(key, value);
};
